// Device-local "continue listening" progress for audiobooks.
const KEY = "abProgress";

function read() {
  try { return JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { return {}; }
}
function write(o) {
  try { localStorage.setItem(KEY, JSON.stringify(o)); } catch { /* ignore quota */ }
}

export function getProgress(id) {
  return read()[id] || null;
}

export function setProgress(id, t, d) {
  if (!id || !d || d <= 0) return;
  const o = read();
  o[id] = { t: Math.floor(t), d: Math.floor(d), updated: Date.now() };
  write(o);
}

export function clearProgress(id) {
  const o = read();
  delete o[id];
  write(o);
}

// Most-recent first; only meaningful, unfinished items.
export function allProgress() {
  const o = read();
  return Object.entries(o)
    .map(([id, v]) => ({ id, ...v }))
    .filter((p) => p.t > 5 && p.d > 0 && p.t < p.d * 0.98)
    .sort((a, b) => b.updated - a.updated);
}

export function fmtTime(sec) {
  if (!sec || sec < 0) return "0:00";
  const s = Math.floor(sec);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const r = s % 60;
  return h > 0 ? `${h}:${String(m).padStart(2, "0")}:${String(r).padStart(2, "0")}` : `${m}:${String(r).padStart(2, "0")}`;
}
